export default {
    props: {
        toolbarClick: {
            type: Function,
            default: undefined,
            kComposite: 'toolbar.click'
        }, 
        toolbarName: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.name'
        }, 
        toolbarText: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.text'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Toolbar.js